import {
  Button as ButtonAntd,
  Card as CardAntd,
  Modal as ModalAtnd,
  Row as RowAntd,
  Typography as TypographyAntd,
} from 'antd';
import styled from 'styled-components';

import colors from '../../../../../../styles/colors';

export const Modal = styled(ModalAtnd)`
  .ant-modal-header {
    border-bottom: 1px solid #bdbdbd;
  }

  .ant-modal-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
  }

  .ant-modal-body {
    min-height: 200px;
    max-height: 1000px;
  }
`;

export const Button = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  padding: 5px 16px 5px 16px;
  border: 1px solid #24a95d;
  border-radius: 2px !important;
  background: #24a95d;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    border-color: #25b663;
    background-color: #25b663;
  }
`;

export const CancelarButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #000;
  padding: 5px 16px 5px 16px;
  border: 1px solid #d9d9d9;
  border-radius: 2px !important;
  background: #ffffff;

  &:hover,
  &:focus {
    color: #000000;
  }
`;

export const Title = styled(TypographyAntd.Paragraph)`
  color: #676a6c !important;
  font-size: 14px !important;
  font-weight: normal !important;
  margin-bottom: 0px !important;
`;

export const Row = styled(RowAntd)`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div``;

export const Label = styled(TypographyAntd.Text)`
  font-size: 16px;
  font-weight: bold;
`;

export const Card = styled(CardAntd)`
  height: 100%;
  width: 100%;

  .ant-card-body {
    padding: 12px;
    background-color: #fafafa;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
  }
`;

export const TitleCard = styled.h1`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
  font-weight: bold;
  margin-bottom: 16px;
`;

export const TextCard = styled(TypographyAntd.Text)`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
  font-weight: bold;
`;

export const TextCardColor = styled(TypographyAntd.Text)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #24a95d;
  font-weight: bold;
`;

export const SubTitle = styled.span`
  display: block;
`;

export const CancelarAgendamentoButton = styled.button`
  width: 100%;
  height: 32px;
  padding: 5px 16px;

  cursor: pointer;

  border: none;
  color: ${colors.$light};
  background: ${colors.$auxiliary_berry_14};
`;

export const AgendamentoLoadingContainer = styled.div`
  width: 100%;
  height: 100px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AvisoFinalizar = styled.h4`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.025em;

  margin-top: -16px;

  color: #d42929;
`;
